import RegisterFormComponents from 'components/form/register';

// execute before app starts
export default function(router) {
	router.beforeEach((to, from, next) => {
		window.scrollTo(0, 0);

		document.body.style.overflowX = 'hidden';

		next();
	});

	RegisterFormComponents('v');
}


// WEBPACK FOOTER //
// ./application/initializer.js